module.exports = __webpack_public_path__ + "static/media/eye-open.64b45282.svg";